/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Group_SystemInputs */

const en_shortcut_keys_group_system = /** @type {(inputs: Shortcut_Keys_Group_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System`)
};

const fr_shortcut_keys_group_system = /** @type {(inputs: Shortcut_Keys_Group_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Systeme`)
};

const de_shortcut_keys_group_system = /** @type {(inputs: Shortcut_Keys_Group_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System`)
};

const it_shortcut_keys_group_system = /** @type {(inputs: Shortcut_Keys_Group_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema`)
};

const ru_shortcut_keys_group_system = /** @type {(inputs: Shortcut_Keys_Group_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Система`)
};

const es_shortcut_keys_group_system = /** @type {(inputs: Shortcut_Keys_Group_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema`)
};

const zh_cn2_shortcut_keys_group_system = /** @type {(inputs: Shortcut_Keys_Group_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系统`)
};

const ja_shortcut_keys_group_system = /** @type {(inputs: Shortcut_Keys_Group_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`システム`)
};

const hi_shortcut_keys_group_system = /** @type {(inputs: Shortcut_Keys_Group_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रणाली`)
};

const pt_pt2_shortcut_keys_group_system = /** @type {(inputs: Shortcut_Keys_Group_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema`)
};

/**
* | output |
* | --- |
* | "System" |
*
* @param {Shortcut_Keys_Group_SystemInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_group_system = /** @type {((inputs?: Shortcut_Keys_Group_SystemInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Group_SystemInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_group_system(inputs)
	if (locale === "de") return de_shortcut_keys_group_system(inputs)
	if (locale === "it") return it_shortcut_keys_group_system(inputs)
	if (locale === "ru") return ru_shortcut_keys_group_system(inputs)
	if (locale === "es") return es_shortcut_keys_group_system(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_group_system(inputs)
	if (locale === "ja") return ja_shortcut_keys_group_system(inputs)
	if (locale === "hi") return hi_shortcut_keys_group_system(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_group_system(inputs)
	return en_shortcut_keys_group_system(inputs)
});